module.exports = __webpack_public_path__ + "static/la-8650b4678ed0cf1a69771d19e7a30595.jpg";